import dayjs from 'dayjs';
import { Transporter } from './transporter.model';

export interface ITheme {
  id?: number;
  updatedDate?: dayjs.Dayjs | null;
  updatedBy?: string | null;
  activated?: boolean | null;
  data?: string | null;
  transporter?: Transporter | null;
}

export class Theme implements ITheme {
  constructor(
    public id?: number,
    public updatedDate?: dayjs.Dayjs | null,
    public updatedBy?: string | null,
    public activated?: boolean | null,
    public data?: string | null,
    public transporter?: Transporter | null
  ) {
    this.activated = this.activated ?? false;
  }
}

export function getThemeIdentifier(theme: ITheme): number | undefined {
  return theme.id;
}
